import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { AuthService } from 'src/app/shared/services/auth.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { RWDService } from '../../services/rwd.service';
import { ContextDataService } from '../../services/context.data-service';

@Component({
  selector: 'app-user-actions',
  templateUrl: './user-actions.component.html',
  styleUrls: ['./user-actions.component.scss']
})
export class UserActionsComponent implements OnInit, OnDestroy {
  @Output() close: EventEmitter<void> = new EventEmitter();

  public currentUserName: string = 'wczytywanie...';

  private subscription$: Subscription = new Subscription();

  constructor(
    public rwdService: RWDService,
    private readonly auth: AuthService,
    private readonly router: Router,
    private ls: LocalizationService,
    private ctxDS: ContextDataService
  ) {}

  ngOnInit(): void {
    this.subscription$.add(
      this.ctxDS.currentUser$.subscribe(
        (user) => (this.currentUserName = ToString.fullName(user) || this.ls.translate('label.noData'))
      )
    );
  }

  ngOnDestroy(): void {
    this.subscription$?.unsubscribe();
  }

  async logOut(): Promise<void> {
    await this.auth.logOut();
    await this.router.navigate(['/signIn']);
    this.close.emit();
  }
}
